export const courses = [
  // Class 8
  {
    id: 1,
    title: "Only Maths by IITians (MI8)",
    courseId: "252612MI8",
    category: "Maths",
    tutor: "Mr Alok Bansal",
    originalPrice: 75000,
    discountedPrice: 15000,
    gstRate: 0.18,
    highlights: [
      "Weekly Assessment and Each Lecture Worksheets.",
      "100% IITian Faculty",
      "1 on 1 Mentorship by IITians.",
      "1 on 1 Doubt Sessions by IITians.",
      "Led by Founder Mr. Alok Bansal (B.Tech. IIT Delhi), with 20+ years of academic leadership and mentoring.",
      "Alok Bhaiya's past results: 2000+ IIT selections, 5000+ across BITS/NITs/NSIT, and JEE AIR 1 (2021)."
    ],
    imageUrl: "/assets/msi8.jpg",
    faculty: [
      { name: "Rahul Kumar", credentials: "B.Tech IIT Goa", imageSrc: "/assets/User.png" },
      { name: "Amit Prakash", credentials: "B.Tech IIT BHU", imageSrc: "/assets/User.png" },
      { name: "Vishal Singh", credentials: "B.Tech IIT Delhi", imageSrc: "/assets/User.png" }
    ],
    duration: "Full Academic Year"
  },
  {
    id: 2,
    title: "Only Science by IITians (SI8)",
    courseId: "252612SI8",
    category: "Science",
    tutor: "Mr Alok Bansal",
    originalPrice: 75000,
    discountedPrice: 15000,
    gstRate: 0.18,
    highlights: [
      "Weekly Assessment and Each Lecture Worksheets.",
      "100% IITian Faculty",
      "1 on 1 Mentorship by IITians.",
      "1 on 1 Doubt Sessions by IITians.",
      "Led by Founder Mr. Alok Bansal (B.Tech. IIT Delhi), with 20+ years of academic leadership and mentoring.",
      "Alok Bhaiya's past results: 2000+ IIT selections, 5000+ across BITS/NITs/NSIT, and JEE AIR 1 (2021)."
    ],
    imageUrl: "/assets/msi8.jpg",
    faculty: [
      { name: "Rahul Kumar", credentials: "B.Tech IIT Goa", imageSrc: "/assets/User.png" },
      { name: "Amit Prakash", credentials: "B.Tech IIT BHU", imageSrc: "/assets/User.png" },
      { name: "Vishal Singh", credentials: "B.Tech IIT Delhi", imageSrc: "/assets/User.png" }
    ],
    duration: "Full Academic Year"
  },
  {
    id: 3,
    title: "Combined Maths & Science by IITians (MSI8: MI8 + SI8)",
    courseId: "252612MSI8",
    category: "Maths & Science (Combo)",
    tutor: "Mr Alok Bansal",
    originalPrice: 150000,
    discountedPrice: 25000,
    gstRate: 0.18,
    highlights: [
      "Weekly Assessment and Each Lecture Worksheets.",
      "100% IITian Faculty",
      "1 on 1 Mentorship by IITians.",
      "1 on 1 Doubt Sessions by IITians.",
      "Led by Founder Mr. Alok Bansal (B.Tech. IIT Delhi), with 20+ years of academic leadership and mentoring.",
      "Alok Bhaiya's past results: 2000+ IIT selections, 5000+ across BITS/NITs/NSIT, and JEE AIR 1 (2021)."
    ],
    imageUrl: "/assets/msi8.jpg",
    faculty: [
      { name: "Rahul Kumar", credentials: "B.Tech IIT Goa", imageSrc: "/assets/User.png" },
      { name: "Amit Prakash", credentials: "B.Tech IIT BHU", imageSrc: "/assets/User.png" },
      { name: "Vishal Singh", credentials: "B.Tech IIT Delhi", imageSrc: "/assets/User.png" }
    ],
    duration: "Full Academic Year"
  },

  // Class 9
  {
    id: 4,
    title: "Only Maths by IITians (MI9)",
    courseId: "252612MI9",
    category: "Maths",
    tutor: "Mr Alok Bansal",
    originalPrice: 75000,
    discountedPrice: 15000,
    gstRate: 0.18,
    highlights: [
      "Weekly Assessment and Each Lecture Worksheets.",
      "100% IITian Faculty",
      "1 on 1 Mentorship by IITians.",
      "1 on 1 Doubt Sessions by IITians.",
      "Led by Founder Mr. Alok Bansal (B.Tech. IIT Delhi), with 20+ years of academic leadership and mentoring.",
      "Alok Bhaiya's past results: 2000+ IIT selections, 5000+ across BITS/NITs/NSIT, and JEE AIR 1 (2021)."
    ],
    imageUrl: "/assets/msi9.jpg",
    duration: "Full Academic Year"
  },
  {
    id: 5,
    title: "Only Science by IITians (SI9)",
    courseId: "252612SI9",
    category: "Science",
    tutor: "Mr Alok Bansal",
    originalPrice: 75000,
    discountedPrice: 15000,
    gstRate: 0.18,
    highlights: [
      "Weekly Assessment and Each Lecture Worksheets.",
      "100% IITian Faculty",
      "1 on 1 Mentorship by IITians.",
      "1 on 1 Doubt Sessions by IITians.",
      "Led by Founder Mr. Alok Bansal (B.Tech. IIT Delhi), with 20+ years of academic leadership and mentoring.",
      "Alok Bhaiya's past results: 2000+ IIT selections, 5000+ across BITS/NITs/NSIT, and JEE AIR 1 (2021)."
    ],
    imageUrl: "/assets/msi9.jpg",
    duration: "Full Academic Year"
  },
  {
    id: 6,
    title: "Combined Maths & Science by IITians (MSI9: MI9 + SI9)",
    courseId: "252612MSI9",
    category: "Maths & Science (Combo)",
    tutor: "Mr Alok Bansal",
    originalPrice: 150000,
    discountedPrice: 25000,
    gstRate: 0.18,
    highlights: [
      "Weekly Assessment and Each Lecture Worksheets.",
      "100% IITian Faculty",
      "1 on 1 Mentorship by IITians.",
      "1 on 1 Doubt Sessions by IITians.",
      "Led by Founder Mr. Alok Bansal (B.Tech. IIT Delhi), with 20+ years of academic leadership and mentoring.",
      "Alok Bhaiya's past results: 2000+ IIT selections, 5000+ across BITS/NITs/NSIT, and JEE AIR 1 (2021)."
    ],
    imageUrl: "/assets/msi9.jpg",
    duration: "Full Academic Year"
  },

  // Class 10
  {
    id: 7,
    title: "Only Maths by IITians (MI10)",
    courseId: "252612MI10",
    category: "Maths",
    tutor: "Mr Alok Bansal",
    originalPrice: 75000,
    discountedPrice: 15000,
    gstRate: 0.18,
    highlights: [
      "Weekly Assessment and Each Lecture Worksheets.",
      "100% IITian Faculty",
      "1 on 1 Mentorship by IITians.",
      "1 on 1 Doubt Sessions by IITians.",
      "Led by Founder Mr. Alok Bansal (B.Tech. IIT Delhi), with 20+ years of academic leadership and mentoring.",
      "Alok Bhaiya's past results: 2000+ IIT selections, 5000+ across BITS/NITs/NSIT, and JEE AIR 1 (2021)."
    ],
    imageUrl: "/assets/msi10.jpg",
    duration: "Full Academic Year"
  },
  {
    id: 8,
    title: "Only Science by IITians (SI10)",
    courseId: "252612SI10",
    category: "Science",
    tutor: "Mr Alok Bansal",
    originalPrice: 75000,
    discountedPrice: 15000,
    gstRate: 0.18,
    highlights: [
      "Weekly Assessment and Each Lecture Worksheets.",
      "100% IITian Faculty",
      "1 on 1 Mentorship by IITians.",
      "1 on 1 Doubt Sessions by IITians.",
      "Led by Founder Mr. Alok Bansal (B.Tech. IIT Delhi), with 20+ years of academic leadership and mentoring.",
      "Alok Bhaiya's past results: 2000+ IIT selections, 5000+ across BITS/NITs/NSIT, and JEE AIR 1 (2021)."
    ],
    imageUrl: "/assets/msi10.jpg",
    duration: "Full Academic Year"
  },
  {
    id: 9,
    title: "Combined Maths & Science by IITians (MSI10: MI10 + SI10)",
    courseId: "252612MSI10",
    category: "Maths & Science (Combo)",
    tutor: "Mr Alok Bansal",
    originalPrice: 150000,
    discountedPrice: 25000,
    gstRate: 0.18,
    highlights: [
      "Weekly Assessment and Each Lecture Worksheets.",
      "100% IITian Faculty",
      "1 on 1 Mentorship by IITians.",
      "1 on 1 Doubt Sessions by IITians.",
      "Led by Founder Mr. Alok Bansal (B.Tech. IIT Delhi), with 20+ years of academic leadership and mentoring.",
      "Alok Bhaiya's past results: 2000+ IIT selections, 5000+ across BITS/NITs/NSIT, and JEE AIR 1 (2021)."
    ],
    imageUrl: "/assets/msi10.jpg",
    duration: "Full Academic Year"
  }
];
